// =============================================================================
// features/sales/campaigns/wizard/components/ImportBatchNotice.tsx — Aviso +
// resumo do lote de importação (etapa 3, fonte "import"). Extraído de
// Step3Hygiene.tsx para manter o orquestrador de etapa abaixo de 200 linhas
// (norma anti-padrão do DS).
// =============================================================================

import * as React from 'react';

import type { ImportBatchSummary } from '../../../../../hooks/sales/useCampaignWizard';

export interface ImportBatchNoticeProps {
  importBatchId: string;
  batch: ImportBatchSummary | undefined;
  isError: boolean;
}

export function ImportBatchNotice({
  importBatchId,
  batch,
  isError,
}: ImportBatchNoticeProps): React.JSX.Element {
  return (
    <div className="flex flex-col gap-3">
      <div
        role="alert"
        className="rounded-sm px-4 py-3 border-l-[3px]"
        style={{ borderColor: 'var(--warning)', background: 'var(--warning-bg)' }}
      >
        <p className="font-sans text-sm font-semibold text-ink">Sem prévia para lotes importados</p>
        <p className="font-sans text-xs text-ink-2 mt-0.5">
          Ao continuar, os clientes do lote são adicionados à carteira imediatamente — não há como
          visualizar antes sem gravar.
        </p>
      </div>

      {importBatchId && batch && (
        <div
          className="rounded-sm border p-4 flex flex-col gap-1"
          style={{ borderColor: 'var(--border-strong)', background: 'var(--surface-1)' }}
        >
          <p className="font-sans text-sm font-semibold text-ink">{batch.fileName}</p>
          <p className="font-sans text-xs text-ink-3">
            Status: {batch.status} — {batch.validRows} de {batch.totalRows} linhas válidas.
          </p>
        </div>
      )}

      {importBatchId && isError && (
        <p className="font-sans text-sm text-danger">
          Não foi possível localizar esse lote — confirme o id ou suas permissões de importação.
        </p>
      )}
    </div>
  );
}
